import React from 'react';

export const EstrellaCalificacion = (props) => {
    const iconoEstrellas = []

    for (let i = 0; i < props.cantidadEstrellas; i++) {
        iconoEstrellas.push(
            <i className={`fa fa-star text-${props.tamaño} ${props.color || 'text-yellow-300' }`}></i>
        );
      }

    return (
        <>
            {iconoEstrellas}
        </>
        
    )
} 
